// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"2b3745fb","453":"8c818b7d"}[chunkId] + ".css";
};